<!-- eslint-disable max-len -->
<template>
  <svg
    class="svg-icon"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    tabindex="0"
    role="button"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
    @mousedown="handleMouseDown"
    @mouseup="handleMouseUp"
    @keydown.enter="handleActive"
    @keyup.enter="handleInactive"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.49379 9.49376L15.5444 9.49376C16.1014 9.49376 16.5529 9.04225 16.5529 8.48532C16.5529 7.92835 16.1014 7.47688 15.5444 7.47688L9.49372 7.47689L9.49376 1.42613C9.49376 0.869166 9.04229 0.417696 8.48532 0.417696C7.92839 0.417736 7.47688 0.869247 7.47688 1.42614L7.47692 7.47681L1.42621 7.47681C0.869277 7.47685 0.417767 7.92836 0.417766 8.48525C0.417766 9.04222 0.869237 9.49369 1.4262 9.49369L7.47692 9.49369L7.47691 15.5444C7.47687 16.1013 7.92838 16.5528 8.48535 16.5528C9.04232 16.5528 9.49379 16.1014 9.49379 15.5444L9.49379 9.49376Z"
      :fill="currentColor"
    />
  </svg>
</template>

<script>
  export default {
    props: {
      color: {
        type: String,
        default: '#C4C4C4',
      },
      hoverColor: {
        type: String,
        default: '#57a9dd',
      },
      activeColor: {
        type: String,
        default: '#2985BF',
      },
    },
    data() {
      return {
        currentColor: this.color,
        isActive: false,
      };
    },
    methods: {
      handleMouseEnter() {
        if (!this.isActive) {
          this.currentColor = this.hoverColor;
        }
      },
      handleMouseLeave() {
        if (!this.isActive) {
          this.currentColor = this.color;
        }
      },
      handleMouseDown() {
        this.isActive = true;
        this.currentColor = this.activeColor;
      },
      handleMouseUp() {
        this.isActive = false;
        this.currentColor = this.hoverColor;
      },
      handleActive() {
        this.isActive = true;
        this.currentColor = this.activeColor;
      },
      handleInactive() {
        this.isActive = false;
        this.currentColor = this.color;
      },
    },
  };
</script>
<style>
  .svg-icon {
    width: 17px;
    height: 17px;
    cursor: pointer;
    outline: none;
  }
</style>
